"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.1.5'] && _();
}
catch (e) { }
